module.exports = __webpack_public_path__ + "static/PrimaryMaths-1e3d261ea6f5aa8ec468baa90eb31b84.jpg";